import axios from 'axios'
const asyncApi = {
  async get (url, data) {
    try {
      let res = await axios.get(url, {params: data})
      res = res.data
      return new Promise((resolve) => {
        resolve(res)
      })
    } catch (err) {
      alert('服务器出错')
      //console.log(err)
    }
  },
  post (url, data) {
    try {
      
      return new Promise((resolve, reject) => {
        axios.post(url, data).then((res)=>{
            resolve(res.data)
        })
        
      })
    } catch (err) {
      // return (e.message)
      alert('服务器出错')
      //console.log(err)
    }
  },
}
export default asyncApi;